import { render, staticRenderFns } from "./ContentPart.vue?vue&type=template&id=20d7ff3f&scoped=true&"
import script from "./ContentPart.vue?vue&type=script&lang=js&"
export * from "./ContentPart.vue?vue&type=script&lang=js&"
import style0 from "./ContentPart.vue?vue&type=style&index=0&id=20d7ff3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7ff3f",
  null
  
)

export default component.exports